module.exports = __webpack_public_path__ + "static/media/dropDownArrow.0d458128.svg";